import { render, staticRenderFns } from "./oldtonew.vue?vue&type=template&id=7d612588&scoped=true&"
import script from "./oldtonew.vue?vue&type=script&lang=js&"
export * from "./oldtonew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d612588",
  null
  
)

export default component.exports